/* lua.js generated code 0.3.0 */

require("clover/const/GameDataConst")
require("clover/const/GamePlayConst")
require("clover/const/GameActionConst")
require("clover/gameGuide/GameGuideConst")
require("clover/const/BannerAdConst")
StageModeConstans = table.const(table(
    [1, "STAGE_MODE_NORMAL", 0],
    [1, "STAGE_MODE_PVP", 1],
    [1, "STAGE_MODE_HIDE_AREA", 2],
    [1, "STAGE_MODE_DIGGER_MATCH", 3]
))
ShareType = table.const(table(
    [1, "WeChat", 1],
    [1, "QQ", 2],
    [1, "Phone", 3],
    [1, "H5", 4],
    [1, "Wechatgame", 7]
))
QQShareType = table.const(table(
    [1, "toQQ", "0"],
    [1, "toQZ", "1"],
    [1, "toWX", "2"],
    [1, "toTL", "3"]
))
QQShareSceneMap = [
    "toQQ",
    "toQZ",
    "toQQ"
]
ShareScene = table.const(table(
    [1, "Session", 0],
    [1, "Timeline", 1],
    [1, "Friends", 2]
))
RouteConst = table.const(table(
    [1, "kUp", 1],
    [1, "kDown", 2],
    [1, "kLeft", 3],
    [1, "kRight", 4],
    [1, "kSimple", 5],
    [1, "kOverLap", 6],
    [1, "kCross", 7],
    [1, "kMaxTile", 8],
    [1, "kInvalid", -1]
))
GamePropsType = table.const(table(
    [1, "kAddStepShare_7", -3],  // 前端专用，用于标识极速分享加7步"
    [1, "kAddStepVideo_2", -2],  // 前端专用，用于标识看视频加2步"
    [1, "kAddStepVideo_1", -1],  // 前端专用，用于标识看视频加1步"
    [1, "kNone", 0],
    [1, "kRefresh", 10001],
    [1, "kLine", 10002],
    [1, "kSwap", 10003],
    [1, "kAdd5_1", 26],
    [1, "kAdd5_2", 1002],
    [1, "kAdd5_3", 1003],
    [1, "kAdd5_4", 1004],
    [1, "kAdd5_5", 1005],
    [1, "kAdd5", 10004],
    [1, "kWrap", 10005],
    [1, "kHammer", 10006],
    [1, "kAdd5_s", 10007],
    [1, "kSuperBird_b", 10008],
    [1, "kSuperBird_b_t_limited", 10111],
    [1, "kSuperBird_b_t_unlimited", 10114],
    [1, "kLine_Wrap_b", 10009],
    [1, "kLine_Wrap_b_t_limited", 10110],
    [1, "kLine_Wrap_b_t_unlimited", 10113],
    [1, "kFourTile_b", 10010],
    [1, "kAdd3_b", 10011],
    [1, "kAdd3_b_t_limited", 10109],
    [1, "kAdd3_b_t_unlimited", 10112],
    [1, "kRefresh_l", 10012],
    [1, "kLine_l", 10013],
    [1, "kSwap_l", 10014],
    [1, "kAdd5_l", 10015],
    [1, "kWrap_l", 10016],
    [1, "kHammer_l", 10017],
    [1, "kEnergy1", 10018],
    [1, "kEnergy2", 10019],
    [1, "kEnergy3", 10020],
    [1, "kEnergyInf", 10021],
    [1, "kRefresh_t", 10022],
    [1, "kLine_t", 10023],
    [1, "kSwap_t", 10024],
    [1, "kWrap_t", 10025],
    [1, "kHammer_t", 10026],
    [1, "kHourglass", 10027],
    [1, "kLine_i", 10028],
    [1, "kHammer_i", 10029],
    [1, "kWrap_i", 10030],
    [1, "kComplementStar", 10038],//限时补星
    [1, "kComplementStar2", 10039],//永久补星道具
    [1, "kUnlimitedenergy_10", 10051],
    [1, "kAddEnergyLimit", 10801],//限时增加精力上限
    [1, "kNameCard", 90001],//新名片
    [1, "kNameDiamond", 91001],//新钻石标志
    [1, "kWeeklyEnergyFull", 90001],
    [1, "kPvpScore", 33],
    [1, "kPvpTicket", 10100],
    [1, "kAdd3_ad", 35],    // 广告+3
    [1, "kLine_Wrap_ad", 36],    // 广告爆炸熊
    [1, "kRefresh_ad", 37],  // 广告刷新
    [1, "kMysteryIslandEnergyFull", 30001], // 神秘岛
    [1, "kSeasideStar_double_15", 39],  // 海滨之星 限时双倍卡15分钟
    [1, "kSeasideStar_double_30", 40],  // 海滨之星 限时双倍卡30分钟
    [1, "kStarDiamond", 45],  // 星石
    [1, "kLevelCollect_double_15", 46],  // 主线收集 限时双倍卡15分钟
    [1, "kLevelCollect_double_30", 47],  // 主线收集 限时双倍卡30分钟
    [1, "kStickerNormal", 48],  // 贴贴 普通贴贴
    [1, "kStickerShine", 49],  // 贴贴 荣耀贴贴
    [1, "kCircusGameTicket", 51],  // 马戏团门票

    [1, "kSalvageGiftAdd5", 56],  // 救援礼包加五步权益

    // 活动投放
    [1, "kSuperBird_Activity", 8001],
    [1, "kLine_Activity", 8002],
    [1, "kFourTile_Activity", 8003],
    [1, "kScoreAnimal", 8004],
    [1, "kLine_Infi", 8005],
    [1, "kAddStep_1_Activity", 8006],
    [1, "kAddStep_2_Activity", 8007],
    [1, "kAddStep_3_Activity", 8008],
    [1, "kAddStep_4_Activity", 8009],
    [1, "kAddStep_5_Activity", 8010],
    [1, "kAddStep_6_Activity", 8011],
    [1, "kAddStep_7_Activity", 8012],
    [1, "kAddStep_8_Activity", 8013],
    [1, "kAddStep_9_Activity", 8014],
    [1, "kAddStep_10_Activity", 8015],
    [1, "kAdd3_infinite", 10200],
    [1, "kLine_Wrap_infinite", 10220],
    [1, "kSuperBird_infinite", 10240],
    [1, "kAdd3_limited", 10300],//关前限时限次加三步（限时48小时）
    [1, "kLine_Wrap_limited", 10320],//关前限时限次直线和爆炸熊（限时48小时）
    [1, "kSuperBird_limited", 10340],//关前限时限次神奇鸟（限时48小时）

    [1, "kNuclear", 999999]
))
GameBoardFallType = table.const(table(
    [1, "kNone", 0],
    [1, "kCannonAll", 5],
    [1, "kCannonAnimal", 39],
    [1, "kCannonBlock", 41],
    [1, "kCannonCoin", 124],
    [1, "kCannonCrystallBall", 125],
    [1, "kCannonHoneyBottle", 127],
    [1, "kCannonGreyCuteBall", 128],
    [1, "kCannonBrownCuteBall", 129],
    [1, "kCnanonBlackCuteBall", 130]
))
TileRoadType = table.const(table(
    [1, "kLine", 1],
    [1, "kCorner", 2],
    [1, "kStartPoint", 3],
    [1, "kEndPoint", 4]
))
TransmissionType = table.const(table(
    [1, "kNone", 0],
    [1, "kRoad", 1],
    [1, "kCorner_UR", 2],
    [1, "kCorner_RD", 3],
    [1, "kCorner_DL", 4],
    [1, "kCorner_LU", 5],
    [1, "kCorner_LD", 6],
    [1, "kCorner_DR", 7],
    [1, "kCorner_RU", 8],
    [1, "kCorner_UL", 9],
    [1, "kStart", 10],
    [1, "kEnd", 11],
    [1, "kSingDir", 12]
))
TransmissionDirection = table.const(table(
    [1, "kNone", 0],
    [1, "kRight", 1],
    [1, "kDown", 2],
    [1, "kLeft", 3],
    [1, "kUp", 4]
))
TransmissionColor = table.const(table(
    [1, "kNone", 0],
    [1, "kRed", 1],
    [1, "kGreen", 2],
    [1, "kBlue", 3]
))
SystemService = table.const(table(
    [1, "kLocation", 1],
    [1, "kProfile", 2],
    [1, "kPhotos", 3],
    [1, "kAppStore", 4],
    [1, "kAppStoreReview", 5],
    [1, "kCamera", 6],
    [1, "kNotification", 7]
))
PrivilegeStatus = table.const(table(
    [1, "kOk", 0],
    [1, "kOff", 1],
    [1, "kDetermind", 2],
    [1, "kDeny", 10]
))
AlertButton = table.const(table(
    [1, "kClose", 1],
    [1, "kOk", 2],
    [1, "kCancel", 4],
    [1, "kAll", 7],
    [1, "kOkCancel", 6],
    [1, "kOkClose", 3]
))
ICON_TYPE = table(
    [1, "kLeft", 1],
    [1, "kRight", 2],
    [1, "kBottom", 3],
    [1, "kTop", 4],
    [1, "kBottomLeft", 5],

)
BOX_ICON_TYPE = table(
    [1, "kTop1", 1],
    [1, "kTop2", 2],
    [1, "kBottom", 3],
)
PaymentErrAction = table(
    [1, "Error", "error"],
    [1, "Cancel", "cancel"],
    [1, "SDKError", "sdkError"],
    [1, "ReqError", "reqError"]
)
PaymentErrCode = table(
    [1, "kNotLogin", -100],
    [1, "kReqCancel", -101],
    [1, "kConfirmCancel", -102],
    [1, "kGoodsInfoNil", -103],
    [1, "kSDKCancel", -104],
    [1, "kLoginCancel", -105],
    [1, "kNoSDK", -106],
    [1, "kVerifiedFailed", -107],
    [1, "kUnspportType", -108],
    [1, "kCashNotEnough", -109],
    [1, "kCoinNotEnough", -110],
    [1, "kDaliyLimit", -112],
    [1, "kMonthlyLimit", -113],
    [1, "kGoodsLimit", -114],
    [1, "kLevelLimit", -115],
    [1, "kGoodsIDInvalid", -116]
)
PLATFORM_INDEX = [
    "unknow",
    "android",
    "ios"
]
DEVIDE_IOS = PLATFORM_INDEX.indexOf("ios")
DEVIDE_ANDROID = PLATFORM_INDEX.indexOf("android")
GOOD_ITEMS = {
    unknow : {
        cash         : 0,
        breakIce1    : 0,
        breakIce2    : 0,
        breakIce3    : 0,
        salePackage1 : 0,
        // discountShop1    : 0,
        // discountShop2    : 0,
        // discountShop3    : 0,
        // discountShop4    : 0,
        // discountShop5    : 0,
        // discountShop6    : 0,
        // discountShop7    : 0,
        // discountShop8    : 0,
        // discountShop9    : 0,
        // discountShop10   : 0,
        // discountShop11   : 0,
        // discountShop12   : 0,
        vipMonthCard     : 0,
        threePackage1    : 0,
        marketThreePackage1   : 0
    },
    android : {
        cash         : 14748,
        breakIce1    : 19213,
        breakIce2    : 19215,
        breakIce3    : 19217,
        salePackage1 : 19219,
        discountShop1    : 20129,
        discountShop2    : 20131,
        discountShop3    : 20133,
        discountShop4    : 20135,
        discountShop5    : 20137,
        discountShop6    : 20139,
        discountShop7    : 20141,
        discountShop8    : 20143,
        discountShop9    : 20145,
        discountShop10   : 20147,
        discountShop11   : 20149,
        discountShop12   : 20151,
        vipMonthCard     : 20615,
        threePackage1    : 22659,
        marketThreePackage1   : 22661
    },
    ios : {
        cash         : 14749,
        breakIce1    : 19214,
        breakIce2    : 19216,
        breakIce3    : 19218,
        salePackage1 : 19220,
        discountShop1    : 20130,
        discountShop2    : 20132,
        discountShop3    : 20134,
        discountShop4    : 20136,
        discountShop5    : 20138,
        discountShop6    : 20140,
        discountShop7    : 20142,
        discountShop8    : 20144,
        discountShop9    : 20146,
        discountShop10   : 20148,
        discountShop11   : 20150,
        discountShop12   : 20152,
        vipMonthCard     : 20616,
        threePackage1    : 22660,
        marketThreePackage1   : 22662
    }
}
ACTIVITY_ICON_TYPE = {
    "default" : 1,
    "typeOne" : 2
}
taskStatus = {
    "starting" : 0,
    "settling" : 1,
    "finish_notreward" : 2,
    "finish_rewarded" : 3,
    "cancel_not_ret_reward"   : 4,
    "cancel_and_rewarded"   : 5
}
participateStatus = {
    "not_start" : 0,
    "starting"  : 1,
    "wait_settle"  : 2,
    "finish_notreward" : 3,
    "finish_rewarded"  : 4,
    "timeouted" : 5
}
PLATFORM_DEF = {
    HE : "he",
    SQ : "sq",
    QZ : "qz"
}
PromptTypeDef = {
    justDot : 1,
    withLabel : 2,
    noDot: 3,
    both: 4,
    newTip: 5,//感叹号
}

ChestType = {
    normal: 1,
    advance: 2
}

IslandType = {
    normal: 1,
    advance: 2
}

IslandStatus = {
    producting: 0,
    canReward: 1
}

IslandUnlockType = {
    "locked": 0,
    "unlocked": 1,
    "placeHolder": 2
}
SystemPlatform = {
    Android:1,
    IOS:2
}

InfinitePrePropsMap = table.const(table(
    [1, GamePropsType.kAdd3_b, GamePropsType.kAdd3_infinite],
    [1, GamePropsType.kLine_Wrap_b, GamePropsType.kLine_Wrap_infinite],
    [1, GamePropsType.kSuperBird_b,  GamePropsType.kSuperBird_infinite],
))
//限时限次-基础道具
LimitedPrePropsMap = table.const(table(
    [1, GamePropsType.kAdd3_b, GamePropsType.kAdd3_limited],
    [1, GamePropsType.kLine_Wrap_b, GamePropsType.kLine_Wrap_limited],
    [1, GamePropsType.kSuperBird_b,  GamePropsType.kSuperBird_limited],
))

//福利中心活动的id -- 对应welfare_center_config
WelfareCenterId = {
    /**星星幸运礼*/
    starDraw: 1,
    /** 免费精力 */
    treasureBox: 2,
    /** 免费礼物 */
    freeGift: 3,
    /** 免费风车币（商店内的看广告拿风车币） */
    freeCoin: 4,
    /** 金币转转转 */
    goldTurn: 5,
    /**月卡 */
    monthTicket: 6,
    /** 通行证 */
    battlePass: 7,
    /** 神秘商店 */
    specialShop: 8,
    /** ai礼包 */
    aiPkg: 9,
    /** 无尽宝藏 */
    endlessTreasure: 10,
    /** 海岛礼包 */
    islandTreasure: 11,
    /** 限定礼包 */
    livegift: 12,
    /** 俄罗斯方块 */
    tetris: 13,
    /** 免广告权益卡 */
    adSkipGiftBag: 14,
    /** 友谊赛 */
    friendPvp: 15,
    /** 敬请期待 */
    unknown: 99,
}

//重玩/退出/复活面板中用到的活动枚举
FailPanelActivity = {
    //紫咪
    PurpleAmyMagic: 1,
    //摘椰子
    PickCoco: 2,
    //主线收集活动
    LevelCollect: 3,
    //萌萌竞速
    LightningRush: 4,
    //晋级赛
    Qualify: 5,
    //海滨通行证
    BattlePass: 6,
    //金币乐园
    GoldElysium: 7,
    //钓鱼大赛
    Fishing: 8,
    //解码特工队
    SecretCode: 9,
    //马戏团
    CircusGame: 10,
    //挖宝石
    ExcavateFood: 11,
    //贴贴
    StickerBattle: 12,
    //投篮王牌
    DunkAce: 13,
    //超鸟
    NuclearBird: 14,
};

/**
 * 信件类型
 */
EmailType = {
    // 通用文本信件
    COMMON_TEXT: 1,
    // 通用文本带附件奖励信件
    COMMON_REWARD: 2,
    // 求超越通知信件
    PASS_LEVEL_SHOW_OFF: 3,
    // 玩家获赠精力
    ENERGY_HELP: 4,
    // 微信游戏圈信件
    WX_GAME_CIRCLE: 5,
}

